import React, {Component} from 'react';
import '../App.css';
import axios from 'axios';

import {
    Link
} from 'react-router-dom'


class Calendar extends Component {

    constructor(props) {
        super(props);
        this.resize = this.resize.bind(this);
        this.state = {isLoading: true};

        this.language = global.api.ValidateLanguage(this.props.route.match.params.language);

        this.PageData = global.api.pagesData["calendarMain"];

        try {
            document.title = this.PageData.title[global.api.CurrentLanguage];
        }
        catch (err) {
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);


        axios.get(global.api.url + this.language + '/List')
            .then(res => {
                this.setState((prevState, props) => {
                    return {isLoading: false, data: res['data']};
                });
            });

    }

    resize() {
        this.forceUpdate();
    }

    render() {

        if (this.state.isLoading === true) {
            return <div className="content" ref={'content'}/>;
        }


        let cellminSize = 150;
        let col_number = Math.floor(this.refs.content.offsetWidth / cellminSize);


        let calendar = this.state.data.map((item, index) => {

            if (item.status === 'open') {

                let name = "";
                let rif = "";

                try {
                    let decodedString = new Buffer(item.data, 'base64').toString();
                    let data_ = JSON.parse(decodedString);

                     name = data_.SubTitle;
                     rif = data_.rif;
                }
                catch (err) {
                }

                return (
                    <Link key={index} to={"/" + this.language + "/" + rif}>
                        <div className="GridCell CellOpen" style={{height: cellminSize, fontSize:'26px'}}>{name}</div>
                    </Link>
                )
            }


            return (
                <div key={index} className="GridCell CellClosed" style={{height: cellminSize}}>{item.day}</div>
            )
        });

        return (
            <div className="ContentSpacer fadeIn" ref={'content'}>

                <div className={"grid"} style={{"gridTemplateColumns": "repeat(" + col_number + ", 1fr)"}}>
                    {calendar}
                </div>

            </div>
        );
    }
}

export default Calendar;




// WEBPACK FOOTER //
// ./src/include/Calendar.js